import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.QuoteItemCommentModal.';
  public static readonly commentTitle = `${Id.prefix}commentTitle`;
  public static readonly updateButton = `${Id.prefix}updateButton`;
  public static readonly closeButton = `${Id.prefix}closeButton`;
}

export class LangQuoteItemCommentModal {
  private constructor() {}
  public static commentTitle(): string {
    return interpolate(Id.commentTitle);
  }
  public static updateButton(): string {
    return interpolate(Id.updateButton);
  }
  public static closeButton(): string {
    return interpolate(Id.closeButton);
  }
}

export class QuoteItemCommentModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.commentTitle, 'Comment', 'Title for the comment modal');
    register.add(Id.updateButton, 'Update', 'Button text for update');
    register.add(Id.closeButton, 'Close', 'Button text for close');
  }
}
